import React from "react";
import { motion } from "framer-motion";

const posColor = (p) => ({ GK: "#ffb800", DEF: "#00e5ff", MID: "#ccff00", FWD: "#ff3b30" }[p] || "#fff");

export const PitchView = ({ lineup = [], teamId }) => {
  const openPlayer = (p) => {
    if (!teamId || !p?.id) return;
    window.dispatchEvent(new CustomEvent("octon:show-player", { detail: { teamId: Number(teamId), playerId: p.id } }));
  };
  return (
    <div className="relative aspect-[3/4] w-full overflow-hidden rounded-2xl border border-white/10"
      style={{ background: "linear-gradient(180deg, #0a1f14 0%, #05130c 100%)" }}
      data-testid="pitch-view">
      {/* pitch markings */}
      <svg viewBox="0 0 100 133" className="absolute inset-0 h-full w-full" preserveAspectRatio="none">
        <g stroke="rgba(255,255,255,0.12)" fill="none" strokeWidth="0.4">
          <rect x="4" y="4" width="92" height="125" />
          <line x1="4" y1="66.5" x2="96" y2="66.5" />
          <circle cx="50" cy="66.5" r="12" />
          <rect x="28" y="4" width="44" height="18" />
          <rect x="28" y="111" width="44" height="18" />
        </g>
      </svg>
      {/* players */}
      {lineup.map((p, i) => (
        <motion.div
          key={p.id}
          initial={{ opacity: 0, scale: 0.4 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: i * 0.05 }}
          className="absolute -translate-x-1/2 -translate-y-1/2"
          style={{ left: `${p.x}%`, top: `${p.y}%` }}
          data-testid={`pitch-player-${i}`}
        >
          <button onClick={() => openPlayer(p)} className="flex flex-col items-center transition hover:scale-110 focus:outline-none" title={`${p.name} — view fitness`}>
            <div
              className="flex h-8 w-8 items-center justify-center rounded-full text-[11px] font-bold text-black shadow-lg"
              style={{ background: posColor(p.position), boxShadow: `0 0 14px ${posColor(p.position)}88` }}
            >
              {p.number || "?"}
            </div>
            <span className="mt-1 max-w-[74px] truncate rounded bg-black/70 px-1 text-[9px] text-white/90">
              {p.name.split(" ").slice(-1)[0]}
            </span>
          </button>
        </motion.div>
      ))}
    </div>
  );
};
